module.exports = __webpack_public_path__ + "static/img/组 2941.b2e9d62.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/planandprepare/images/组 2941.png
// module id = TbYN
// module chunks = 0